import { Tooltip } from "flowbite-react";
import { useState } from "react";
import { Popup } from "../../../components/pop-up";
import { IconButton } from "../../../components/buttons";
import { ACL } from "../../../components/acl";
import { SUPERADMIN } from "../../../constants/roles";

export function DeleteCoworkerAction(props) {
  const [openModal, setOpenModal] = useState();
  return (
    <ACL showFor={[SUPERADMIN]}>
      <Tooltip
        content={
          props?.data?.is_active
            ? "Deactivate before deleting a Coworker "
            : "Delete Coworker"
        }
        placement="bottom"
      >
        <IconButton
          disabled={props?.data?.is_active}
          onClick={() => {
            setOpenModal("pop-up");
          }}
          // class="disabled:cursor-not-allowed disabled:text-gray-400 disabled:hover:bg-indigo-50 rounded-xl bg-indigo-100 p-2 text-indigo-600 hover:bg-indigo-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-4 h-4"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
            />
          </svg>
        </IconButton>
      </Tooltip>
      <Popup
        content={
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="stroke-red-600 mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
              />
            </svg>
            <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
              Are you sure you want to delete{" "}
              <b className="text-red-500">{props?.data?.fullName}</b>?
            </h3>
          </>
        }
        cancelText="No, cancel"
        confirmText={`Yes, proceed`}
        confirmClass="bg-red-600 text-white"
        modalState={[openModal, setOpenModal]}
        onConfirm={() => {
          props.onConfirm && props.onConfirm(props.data);
          setOpenModal(undefined);
        }}
      />
    </ACL>
  );
}
